<template>
  <div v-if="
  this.enableAccessAuthSearch('E8') === true ||
  this.getCurrentPage === '/userdash'
  ">
    <div v-if="btnSpinGetRegisterList === false">
      <v-btn
      :color="ui.btnColor"
      icon v-if="data.size == 'icon'"
      @click="getReportList()"
      flat dark>
        <v-icon :color="btn.Color"> {{btn.icon}} </v-icon>
      </v-btn>
      <v-btn
      :color="ui.btnColor"
      v-if="data.size == 'flat' || data.size == undefined"
      @click="getReportList()"
      flat dark>
        <v-icon left :color="btn.Color"> {{btn.icon}} </v-icon>
          {{btn.title}}
      </v-btn>
    </div>
    <div v-else>
      <BtnSpin dark v-if="data.size == 'icon'" :btnSpec="btnInfo1"/>
      <BtnSpin dark v-if="data.size == 'flat'" :btnSpec="btnInfo2"/>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import accessFunctions from "@/support/access/mixins/accessFunctions.js";
import BtnSpin from "@/frame/animation/components/BtnSpin";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import registerFunctions from "@/data/functions/mixins/registerFunctions.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
export default {
  // eslint-disable-next-line
  mixins: [
    apptheme,
    getList,
    storeFunctions,
    routerFunctions,
    registerFunctions,
    dataSources,
    accessFunctions
  ],
  methods: {
    getReportList() {
      // getReportList(tag, tagd, tags, check)
      this.btnSpinGetRegisterList = true;
      // TITLE
      // let tagX = "E8";
      let title = "Technical Results";
      this.$store.dispatch("changePageTitle", title);
      // CHANGE REPORT REGISTER INFO
      // console.log("PPPPPPPPPPP");
      // console.log(this.data.dis);
      let reg = {
        title: null,
        dis: this.data.dis,
        type: "list"
      };
      this.$store.dispatch("changeRegisterInfo", reg);
      // GET LIST
      this.getReportsANDResults({ dis: this.data.dis });
    }
  },
  computed: {
    ...mapGetters(["getCurrentPage", "getDetailBasic", "getUser"]),
    btn() {
      let obj = {
        title: "",
        icon: "",
        color: ""
      };
      if (this.getCurrentPage === "/facilitydashreport") {
        obj.title = "results";
        obj.icon = "sort";
        obj.color = this.ui.btnColor;
      } else {
        obj.title = "undefined";
        obj.icon = "sort";
        obj.color = this.ui.btnColor;
      }
      return obj;
    }
  },
  props: {
    data: {
      type: Object
    }
  },
  components: {
    BtnSpin
  },
  data() {
    return {
      valid: false,
      btnSpinGetRegisterList: false,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "icon"
      },
      btnInfo2: {
        color: "red",
        icon: "person",
        name: "add user",
        btnType: "flat"
      }
    };
  }
};
</script>
